// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// const exportToExcel = (orders, fileName = "orders.xlsx") => {
//   const formattedData = orders.map((order) => ({
//     "Invoice No": order.invoiceNumber,
//     "Order ID": order.orderId,
//     "Order Status": order.orderStatus,
//     "Order Total": order.orderTotal,
//     "Payment Status": order.paymentStatus,
//     "Payment Type": order.paymentType,
//     "Customer Name": `${order.customerAddressDetail?.firstName} ${order.customerAddressDetail?.lastName}`,
//     "Mobile Number": order.customerAddressDetail?.mobileNumber,
//     "Address": `${order.customerAddressDetail?.cityTitle}, ${order.customerAddressDetail?.stateTitle}, ${order.customerAddressDetail?.countryTitle}`,
//     "Item Name": order.itemDetailList[0]?.title || "",
//     "Quantity": order.itemDetailList[0]?.quantity || 0,
//     "Selling Price": order.itemDetailList[0]?.sellingPrice || 0,
//     "Subtotal": order.subTotal,
//     "Delivery Charges": order.deliveryCharges,
//     "Packing Charges": order.packingCharges,
//     "Created At": new Date(order.createdAt).toLocaleDateString(),
//   }));

//   // Convert to a worksheet
//   const ws = XLSX.utils.json_to_sheet(formattedData);

//   // Create workbook
//   const wb = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, "Orders");

//   // Write and save the file
//   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//   const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
//   saveAs(dataBlob, fileName);
// };

// export default exportToExcel;

import React, { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import { LuArrowUpDown } from "react-icons/lu";
import { FaArrowUpLong, FaArrowDownLong } from "react-icons/fa6";

const OrderExport = ({ orders }) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [city, setCity] = useState("");
  const [status, setStatus] = useState("");
  const [reportName, setReportName] = useState("");

  const [errors, setErrors] = useState({});
  const handleValidation = () => {
    let newErrors = {};
    if (!reportName?.trim() || !toDate?.trim() || !fromDate?.trim()) newErrors.title = "titel is required";
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return false;
    }
    return true;
  };

  const [filterData, setFilterData] = useState(orders);
  useEffect(() => {
    setFilterData(orders);
  }, [orders]);


  // 📌 Filter Function
  const filterOrders = () => {
    const filtered = orders.filter((order) => {
      const orderDate = new Date(order.createdAt).getTime();
      const fromTimestamp = fromDate ? new Date(fromDate).getTime() : null;
      const toTimestamp = toDate ? new Date(toDate).getTime() : null;

      return (
        (!fromDate || !toDate || (orderDate >= fromTimestamp && orderDate <= toTimestamp)) &&
        (!city || order.customerAddressDetail?.cityTitle.toLowerCase() === city.toLowerCase()) &&
        (!status || order.orderStatus.toLowerCase() === status.toLowerCase())
      );
    });

    setFilterData(filtered); // 👈 Save filtered orders to state
    return filtered;
  };

  // 📌 Excel Download Function
  const downloadExcelSheet = () => {
    handleValidation()
    if (handleValidation()) {
      downloadFilteredExcel();
    }
  }
  const downloadFilteredExcel = () => {
    let filteredData = filterOrders();

    // **Formatted Data for Excel**
    const formattedData = filteredData.map((order, index) => ({
      "Sr": `${index + 1}`,
      "Invoice No": order.invoiceNumber,
      "Customer Name": `${order.customerAddressDetail?.firstName} ${order.customerAddressDetail?.lastName}`,
      "Customer Mobile No.": order.customerDetail?.userCustomerMobile,
      "Items": `${order.itemDetailList?.map((itm) => itm.title)}`,
      "Quantity": `${order.itemDetailList?.map((itm) => itm.quantity)}`,
      "Rate": `${order.itemDetailList?.map((itm) => itm.sellingPrice)}`,
      "Tax": `${order.itemDetailList?.map((itm) => itm.taxDetails.parentTitle)}`,
      "Discount": order.couponDiscountAmount,
      "Total Rate": order.orderTotal,
      "Payment Type": order.paymentType,
      "Selling Price": `${order.itemDetailList?.map((itm) => itm.sellingPrice)}`,
      "Subtotal": order.subTotal,
      "Ship Date": timeFormate(order.orderAt),
      "Delivery Date": `${order?.orderStatusLogList?.map((itm) => timeFormate(itm?.modifiedAt))}`,
    }));

    // *  * Adding Report Name & Filters on Top  *  *

    let reportTitle = [[`${reportName}`], [""]];
    let filterInfo = [["Filters Applied:"]];
    if (fromDate && toDate) filterInfo.push([`Date Range: ${fromDate} to ${toDate}`]);
    if (city) filterInfo.push([`City: ${city}`]);
    if (status) filterInfo.push([`Status: ${status}`]);
    filterInfo.push([""]); // Empty row for spacing

    // **Convert JSON to Excel Sheet Format**
    let worksheet = XLSX.utils.json_to_sheet(formattedData, { origin: filterInfo.length + 2 });

    // **Adding Report Name & Filter Info at Top**
    XLSX.utils.sheet_add_aoa(worksheet, reportTitle, { origin: "A1" });
    XLSX.utils.sheet_add_aoa(worksheet, filterInfo, { origin: "A3" });

    // **Workbook Creation**
    let workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Filtered Orders");

    // **Download Excel File**
    XLSX.writeFile(workbook, `${reportName || "Filtered_Orders"}.xlsx`);
  };

  const timeFormate = (time) => {
    try {
      // Check if the time is valid
      const date = new Date(time);
      if (isNaN(date)) {
        throw new Error("Invalid date");
      }

      const options = {
        day: 'numeric',    // 5
        month: 'numeric',    // Dec
        year: 'numeric',   // 2024
        hour: '2-digit',   // 10
        minute: '2-digit',
        hour12: true
      };

      const formattedDate = new Intl.DateTimeFormat('en-GB', options).format(date);
      return formattedDate;
    } catch (error) {
      console.error("Invalid time value:", error.message);
      return "Invalid Date";
    }
  };
  const [sortState, setSortState] = useState({
    type: null, // e.g. "Invoice" or "CustomerName"
    direction: null, // "asc", "desc", or null
  });

  const handleListSort = (type) => {
    let nextDirection;
    if (sortState.type !== type) {
      nextDirection = "asc";
    } else if (sortState.direction === "asc") {
      nextDirection = "desc";
    } else if (sortState.direction === "desc") {
      nextDirection = null;
    } else {
      nextDirection = "asc";
    }
    setSortState({ type: nextDirection ? type : null, direction: nextDirection });

    if (!nextDirection) {
      setFilterData(orders);
      return;
    }
    const sorted = [...orders].sort((a, b) => {
      if (type === "Invoice") {
        return nextDirection === "asc"
          ? a.invoiceNumber - b.invoiceNumber
          : b.invoiceNumber - a.invoiceNumber;
      }

      if (type === "CustomerName") {
        const aName = a.customerAddressDetail?.firstName?.toLowerCase() || "";
        const bName = b.customerAddressDetail?.firstName?.toLowerCase() || "";
        return nextDirection === "asc"
          ? aName.localeCompare(bName)
          : bName.localeCompare(aName);
      }
      return 0;
    });

    setFilterData(sorted);
  };

  const handlePrint = () => {
    const printtWindow = window.open('', '_blank');
    printtWindow.document.write(`
        <html>
        <head>
          <style>
            body {
              font-family: Arial, sans-serif;
            }
        
            .container {
              width: 100%;
              border: 1px solid #ccc;
              border-collapse: collapse;
            }
        
            .header {
              background-color: #0099A8;
              color: white;
              font-weight: bold;
              padding: 10px;
              font-size: 20px;
            }
        
            .sub-header {
              background-color: #e8f6f7;
              padding: 10px;
            }
        
            .info-row {
              display: flex;
              justify-content: space-between;
              padding: 10px;
              background-color: #f9f9f9;
            }
        
            .info-row div {
              flex: 1;
              margin-right: 10px;
            }
        
            .info-label {
              font-weight: bold;
            }
        
            .info-input {
              background-color: #e8f6f7;
              border: none;
              padding: 3px;
              width: 90%;
            }
        
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 10px;
            }
        
            th, td {
              border: 1px solid #ccc;
              padding: 8px;
              text-align: left;
              background-color: #f9fff9;
            }
        
            th {
              background-color: #e8f6f7;
              font-weight: bold;
            }
        
            tr:nth-child(even) td {
              background-color: #e9ffe9;
            }
          </style>
        </head>
        <body>
        
          <div class="header">Company Name: TheBooks24</div>
          <div class="sub-header"><strong>Address: shri shyam book depot, main kanta churaha, khrini phatak road, jhotwara, jaipur-302012</strong></div>
        
          <div class="info-row">
            <div><span class="info-label">Phone No.: 8529693113</span> <input class="info-input" type="text" /></div>
            <div><span class="info-label">Email ID: thebooks24india@gmail.com</span> <input class="info-input" type="text" /></div>
            <div><span class="info-label">Date: </span> <input class="info-input" type="text" /></div>
          </div>
        
          <table>
            <thead>
              <tr>
                <th>DATE</th>
                <th>Order No.</th>
                <th>Invoice No.</th>
                <th>Party Name</th>
                <th>Party Phone No.</th>
                <th>Total Amount</th>
                <th>Received/Paid Amount</th>
                <th>Balance Amount</th>
              </tr>
            </thead>
            <tbody>
              <!-- Empty rows -->
              ${filterData.map((_, index) => `
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        
        </body>
        </html>
        `);
    printtWindow.document.close();
    printtWindow.print();
  };

  return (
    <div>
      <div className="report-container" style={{ width: "100%" }}>
        <div className="filters">
          <lable>Report Name</lable>
          <input type="text" className="w-100" onChange={(e) => { setReportName(e.target.value); setErrors({}) }} placeholder="Enter report name" />
          <label>District</label>
          <input type="text" className="w-100" placeholder="Enter Districts" onChange={(e) => { setCity(e.target.value); setErrors({}) }} />
          <label>Status</label>
          <select onChange={(e) => { setStatus(e.target.value); setErrors({}) }}>
            <option value="">All</option>
            <option value="ORDER">ORDER</option>
            <option value="SHIPPED">SHIPPED</option>
            <option value="DELIVERED">DELIVERED</option>
          </select>

          <input type="date" onChange={(e) => { setFromDate(e.target.value); setErrors({}) }} />
          <input type="date" onChange={(e) => { setToDate(e.target.value); setErrors({}) }} />
          <button className="search-btn" onClick={() => filterOrders()}>Search</button>
          {errors?.title && <span style={{ color: "red", marginTop: "10px" }}>Please fill all the fields</span>}
        </div>
        <div className="download-buttons">
          <button className="download-excel" onClick={downloadExcelSheet}>Download Excel</button>
          <button className="download-pdf" onClick={handlePrint}>Download PDF</button>
        </div>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Invoice No. <span className="sort-report" onClick={() => handleListSort("Invoice")}><FaArrowUpLong style={sortState.type === "Invoice" && sortState.direction === "asc" && { color: "#817979" }} /><FaArrowDownLong style={sortState.type === "Invoice" && sortState.direction === "desc" && { color: "#817979" }} /></span></th>
                <th>Customer Name <span className="sort-report" onClick={() => handleListSort("CustomerName")}><FaArrowUpLong style={sortState.type === "CustomerName" && sortState.direction === "asc" && { color: "#817979" }} /><FaArrowDownLong style={sortState.type === "CustomerName" && sortState.direction === "desc" && { color: "#817979" }} /></span></th>
                <th>Customer Mobile No. </th>
                <th>Items <span className="sort-report"><FaArrowUpLong style={sortState.type === "items" && sortState.direction === "asc" && { color: "#817979" }} /><FaArrowDownLong style={sortState.type === "items" && sortState.direction === "desc" && { color: "#817979" }} /></span></th>
                <th>Quantity <span className="sort-report"><FaArrowUpLong /><FaArrowDownLong style={{ color: "red" }} /></span></th>
                <th>Rate <span className="sort-report"><FaArrowUpLong /><FaArrowDownLong style={{ color: "red" }} /></span></th>
                <th>Tax Detail</th>
                <th>Discount <span className="sort-report"><FaArrowUpLong /><FaArrowDownLong style={{ color: "red" }} /></span></th>
                <th>Total Rate <span className="sort-report"><FaArrowUpLong /><FaArrowDownLong style={{ color: "red" }} /></span></th>
                <th>Payment Mode <span className="sort-report"><FaArrowUpLong /><FaArrowDownLong style={{ color: "red" }} /></span></th>
                <th>Ship Date <span className="sort-report"><FaArrowUpLong /><FaArrowDownLong style={{ color: "red" }} /></span></th>
                <th>Delivery Date <span className="sort-report"><FaArrowUpLong /><FaArrowDownLong style={{ color: "red" }} /></span></th>
              </tr>
            </thead>
            <tbody>
              {filterData?.map((item, index) => (
                <tr key={item.uuid}>
                  <td>{index + 1}</td>
                  <td>{item.invoiceNumber}</td>
                  <td>{item.customerAddressDetail?.firstName} {item.customerAddressDetail?.lastName}</td>
                  <td>{item.customerDetail?.userCustomerMobile}</td>
                  <td>{item.itemDetailList?.map((itm, index) => {
                    return (
                      <>
                        <span><b>{index + 1}.</b> {itm.title}</span><br />
                      </>
                    )
                  })}
                  </td>
                  <td>{item.itemDetailList?.map((itm, index) => {
                    return (
                      <>
                        <span><b>{index + 1}.</b> {itm.quantity}</span><br />
                      </>
                    )
                  })}
                  </td>
                  <td>{item.itemDetailList?.map((itm, index) => {
                    return (
                      <>
                        <span><b>{index + 1}.</b> {itm.sellingPrice}</span><br />
                      </>
                    )
                  })}
                  </td>
                  <td>{item.itemDetailList?.map((itm) => {
                    return (
                      <>
                        <span>{itm.taxDetails?.parentTitle}</span><br />
                      </>
                    )
                  })}
                  </td>
                  <td>{item.couponDiscountAmount}</td>
                  <td>{item.orderTotal}</td>
                  <td>{item.paymentType}</td>
                  <td>{timeFormate(item.orderAt)}</td>
                  <td>{item?.orderStatusLogList?.map((itm) => timeFormate(itm?.modifiedAt))}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OrderExport;